import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { academyProgramEndpoint } from "@/config/endpoints";

export default function usePrograms() {
  const query = useQuery({
    queryKey: ["academy", "programs"],
    queryFn: async () => {
      const res = await axiosInstance.get(academyProgramEndpoint);
      return res.data?.programs ?? res.data ?? [];
    },
  });

  const raw = Array.isArray(query.data) ? query.data : [];
  const data = raw
    .filter((p: any) => !p.name?.startsWith("[ARCHIVED]"))
    .map((p: any) => ({
      ...p,
      variants: (p.variants ?? []).filter(
        (v: any) => !v.name?.startsWith("[ARCHIVED]")
      ),
    }));
  const programSelects =
    data?.map((val: any) => ({
      value: String(val.id),
      name: val.name ?? val.title ?? "Unnamed",
    })) ?? [];

  return {
    programs: data,
    programSelects,
    length: data.length,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
